import { createSlice } from "@reduxjs/toolkit";

import { clearStore } from "actions/initialization";
import {
  STRIPE_SUBSCRIPTION_INTERVALS,
  STRIPE_SUBSCRIPTION_TYPES,
} from "../constants";
import {
  checkoutSessionThunk,
  customerPortalThunk,
  subscriptionsListThunk,
} from "thunks/stripe";
import { isPendingAction, isRejectedAction } from "utils";

export const initialState = {
  prices: [],
  activePriceId: null,
  planName: null,
  currentPlan: undefined,
  interval: null,
  loading: false,
  loadingSubscription: Object.keys(STRIPE_SUBSCRIPTION_TYPES).reduce(
    (clone, key) => ({
      [key]: false,
      ...clone,
    }),
    {}
  ),
  error: null,
};

const actionsToFilter = {
  pending: [customerPortalThunk.pending, subscriptionsListThunk.pending],
  fulfilled: [],
  rejected: [customerPortalThunk.rejected, subscriptionsListThunk.rejected],
};

const stripeSlice = createSlice({
  name: "stripe",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // #region pending
      .addCase(checkoutSessionThunk.pending, (state, action) => {
        const { price } = action.meta.arg;
        state.loadingSubscription[price] = true;
      })
      // #endregion
      // #region fulfilled
      .addCase(subscriptionsListThunk.fulfilled, (state, action) => {
        const { prices, active_price_id } = action.payload;
        state.loading = false;
        const currentPlan = prices.find((plan) => plan.id === active_price_id);
        // fyi tmp subscription & subscriptions without name exit on ov env stripe
        const _prices = prices.map((price) => {
          if (
            price.interval === STRIPE_SUBSCRIPTION_INTERVALS.month &&
            price.name &&
            !price.name.includes("pro") &&
            !price.name.includes("tmp")
          )
            return {
              ...price,
              priceId: STRIPE_SUBSCRIPTION_TYPES.month,
            };
          if (
            price.interval === STRIPE_SUBSCRIPTION_INTERVALS.year &&
            price.name &&
            !price.name.includes("pro") &&
            !price.name.includes("tmp")
          )
            return {
              ...price,
              priceId: STRIPE_SUBSCRIPTION_TYPES.year,
            };
          if (
            price.interval === STRIPE_SUBSCRIPTION_INTERVALS.month &&
            price.name &&
            !price.name.includes("tmp")
          )
            return { ...price, priceId: STRIPE_SUBSCRIPTION_TYPES.monthPro };
          if (
            price.interval === STRIPE_SUBSCRIPTION_INTERVALS.year &&
            price.name &&
            !price.name.includes("tmp")
          )
            return { ...price, priceId: STRIPE_SUBSCRIPTION_TYPES.yearPro };
        });
        state.prices = prices;
        state.activePriceId = active_price_id;

        if (currentPlan) {
          state.interval = currentPlan.interval;
        }
        state.currentPlan = currentPlan?.name;
      })
      .addCase(checkoutSessionThunk.fulfilled, (state, action) => {
        const { price } = action.meta.arg;
        state.loadingSubscription[price] = false;
      })
      // #endregion
      // #region rejected
      // #endregion
      .addCase(clearStore, () => initialState)

      .addCase(checkoutSessionThunk.rejected, (state, action) => {
        const { price } = action.meta.arg;
        state.loadingSubscription[price] = false;
      })
      .addMatcher(isPendingAction(actionsToFilter.pending), (state) => {
        state.loading = true;
      })
      .addMatcher(
        isRejectedAction(actionsToFilter.rejected),
        (state, action) => {
          const { error } = action;
          state.loading = false;
          state.error = error;
        }
      );
  },
});

export const actions = stripeSlice.actions;

export default stripeSlice.reducer;
